export default __webpack_public_path__ + "static/media/p-form.1935eb4e.jpg";